// Start the Webflow OAuth connect flow for the logged-in user.
//
// The OAuth `state` is minted by the backend and bound to the JWT user in
// Redis (single-use, 10 min); the browser never builds or carries it. The
// backend answers with the authorize URL and we navigate there. Webflow
// sends the user back to /webflow-register, which posts code + state to
// POST /api/auth/webflow/check_account (body, never query string).
const API = process.env.REACT_APP_API_BASE_URL;

// After a Disconnect the Webflow authorization is kept for this browser
// (Webflow toolkit 2026-10-27: Disconnect ends only the account link, and the
// customer connects again without a new Webflow OAuth). So a connect first
// asks the backend to attach that parked authorization to the signed-in
// account; only when there is none does it start the OAuth flow.
// Resolves { reconnected: true } when no navigation was needed. `authorize`
// skips the reconnect: the customer wants Webflow's site selection itself
// (e.g. no site was allowed), which only the authorization screen offers.
export async function startWebflowConnect({ botId = null, returnTo = null, authorize = false } = {}) {
  if (!authorize) {
    try {
      const again = await fetch(`${API}auth/webflow/reconnect`, { method: 'POST' });
      if (again.ok) {
        const d = await again.json().catch(() => ({}));
        if (d.status === 'connected') return { reconnected: true };
      }
    } catch { /* nothing parked or offline: the OAuth flow below */ }
  }
  const r = await fetch(`${API}auth/webflow/connect/start`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bot_id: botId || null, return_to: returnTo || null }),
  });
  if (!r.ok) {
    const d = await r.json().catch(() => ({}));
    throw new Error(d.detail || `connect/start failed (${r.status})`);
  }
  const { authorize_url: authorizeUrl } = await r.json();
  if (!authorizeUrl || !/^https:\/\/webflow\.com\//.test(authorizeUrl)) {
    throw new Error('unexpected authorize URL');
  }
  window.location.href = authorizeUrl;
}
